const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY

const stripe = window.Stripe(STRIPE_PUBLISHABLE_KEY)

export default stripe
